import React from 'react';
import { Button } from '../components/ui/button';
import { UserPlus } from '@phosphor-icons/react';
import { useAgency } from '../context/AgencyContext';
import { useStaffInvitations } from './staff-invitations/useStaffInvitations';
import InvitationsStatsCards from './staff-invitations/InvitationsStatsCards';
import InvitationsFilters from './staff-invitations/InvitationsFilters';
import InvitationsTable from './staff-invitations/InvitationsTable';
import CreateInvitationDialog from './staff-invitations/CreateInvitationDialog';
import InvitationLinkDialog from './staff-invitations/InvitationLinkDialog';

const StaffInvitationsPage = () => {
  const { currentAgency, isAzaiStaff, azaiRole } = useAgency();
  const {
    invitations,
    loading,
    statusFilter,
    setStatusFilter,
    createOpen,
    setCreateOpen,
    linkOpen,
    setLinkOpen,
    selectedInvitation,
    formData,
    setFormData,
    submitting,
    openCreate,
    handleCreate,
    handleRevoke,
    handleResend,
    copyInviteLink,
  } = useStaffInvitations();

  const canManageInvitations =
    (isAzaiStaff && ['super_admin', 'billing_manager'].includes(azaiRole)) || true;

  return (
    <div className="space-y-6 animate-fade-in" data-testid="staff-invitations-page">
      {/* Header */}
      <div className="flex justify-between items-start">
        <div>
          <h1
            className="text-3xl font-bold text-slate-900"
            style={{ fontFamily: 'Manrope' }}
          >
            Staff Invitations
          </h1>
          <p className="text-slate-500 mt-1">
            Invite new staff members to {currentAgency?.name || 'your agency'}
          </p>
        </div>
        {canManageInvitations && (
          <Button onClick={openCreate} data-testid="create-invitation-btn">
            <UserPlus size={18} className="mr-2" />
            Invite Staff
          </Button>
        )}
      </div>

      <InvitationsStatsCards invitations={invitations} />

      <InvitationsFilters
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
      />

      <InvitationsTable
        invitations={invitations}
        loading={loading}
        canManage={canManageInvitations}
        onCreate={openCreate}
        onCopy={copyInviteLink}
        onRevoke={handleRevoke}
        onResend={handleResend}
      />

      <CreateInvitationDialog
        open={createOpen}
        onOpenChange={setCreateOpen}
        formData={formData}
        setFormData={setFormData}
        submitting={submitting}
        onSubmit={handleCreate}
        agencyName={currentAgency?.name}
      />

      <InvitationLinkDialog
        open={linkOpen}
        onOpenChange={setLinkOpen}
        invitation={selectedInvitation}
        onCopy={copyInviteLink}
      />
    </div>
  );
};

export default StaffInvitationsPage;
